<!--
 * @Description: 评估收款详情组件
 * @Author: gaohc，wanq
 * @Date: 2022-03-16 16:43:52
-->
<template>
  <div class="body">
    <el-dialog class="order-details-dialog" width="83%" title="评估收款详情"
      :visible.sync="visible" :close-on-click-modal="false" @open="initData"
      :before-close="handleCancel" center>
      <div class="dialog-body">
        <div class="order-msg-main">
          <el-descriptions title="" :column="20" direction="vertical">
            <el-descriptions-item :span="5" label="评估人">
              {{ orderData.evaluatorName || '- -' }}
            </el-descriptions-item>
            <el-descriptions-item :span="5" label="评估时间">
              {{ order.evaluatorTime || '- -' }}
            </el-descriptions-item>
            <el-descriptions-item :span="5" label="支付方式">
              {{ orderData.payTypeTxt || "- -" }}
            </el-descriptions-item>
            <el-descriptions-item :span="5" label="订单号">
              {{ order.no }}
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <div class="collect-money-main">
          <el-descriptions direction="vertical" :column="3" border title="评估收款">
            <el-descriptions-item label="订单原价">
              ￥{{ order.totalAmountYuan }}
            </el-descriptions-item>
            <el-descriptions-item label="议价差额">
              <span style="color: #ff403f">
                ￥{{ order.differenceAmountYuan }}
              </span>
            </el-descriptions-item>
            <el-descriptions-item label="应付款">
              ￥{{ order.payableAmountYuan }}
            </el-descriptions-item>
          </el-descriptions>
          <div class="remarks-main">
            <span style="color: #828f9f">备注信息：</span>
            <span>{{ order.remark ? order.remark : "- -" }}</span>
          </div>
        </div>
        <div class="pay-voucher-main">
          <div class="header-title">支付凭证</div>
          <el-row v-if="orderData.imgPathList && orderData.imgPathList.length" type="flex" class="row-bg">
            <el-col :span="6" v-for="(item, idx) in orderData.imgPathList"
			        style="margin-right: 80px" :key="idx">
              <div class="grid-content bg-purple">
                <div class="voucher-image-container">
                  <el-image style="height: 100%" fit="fill" :preview-src-list="previewList" :src="loadImage(item)">
				          </el-image>
                </div>
              </div>
            </el-col>
          </el-row>
          <div v-else>暂无支付凭证信息...</div>
        </div>
      </div>
      <div class="dialog-footer bk-wizard-bottons">
        <el-button @click="handleCancel">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Constant from "@/global/Constant.js";

export default {
  name: "CollecMoneyDetails",
  props: ["visible", "orderId"],

  data() {
    return {
      dataTable: [],
      orderData: {},
      order: {},
      previewList: [],
    };
  },

  computed: {
    loadImage() {
      return (path) => {
        return path ? this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE,
          path) : "";
      };
    }
  },

  methods: {
    handleCancel() {
      this.$emit("close-dialog", false);
    },

    handleClickCollectdetails() {
      this.$emit("check-collectdetails");
    },

    //获取凭证图片预览列表
    getPreviewList(imgList) {
      imgList.map((path) => {
        let imgSrc = this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, path);
        this.previewList.push(imgSrc);
      });
    },

    initData() {
      let params = {id: this.orderId};
      let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(params,
        Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_ORDER_PAYMENT_DETAILS,
        param: esParam,
        header: header,
        contentType: this.commonConst.CNTYPE_JSON,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }

        this.orderData = result.data;
        this.order = result.data.order;
        if (this.orderData.imgPathList && this.orderData.imgPathList.length) {
          this.getPreviewList(this.orderData.imgPathList);
        }
      });
    }
  }
};
</script>

<style scoped>
.order-details-dialog /deep/ .el-dialog__header {
  text-align: center;
}

.order-details-dialog .dialog-body {
  padding: 0 25px 50px 25px;
}

.order-msg-main {
  padding: 20px 20px 0 20px;
}

.order-msg-main,
.order-msg-main /deep/ .el-descriptions__body {
  background-color: #f5f6fa;
}

.order-msg-main /deep/ .el-descriptions-item__label {
  color: #7c899a;
  font-size: 15px;
}

.order-msg-main /deep/ .el-descriptions-item__content {
  font-size: 15px;
  font-weight: 600;
  color: #000000;
}

.collect-money-main {
  margin-top: 35px;
  width: 360px;
}

.collect-money-main /deep/ .el-descriptions-item__content {
  font-size: 15px;
  font-weight: 600;
  color: #000000;
  text-align: center;
}

.collect-money-main /deep/ .el-descriptions-item__label {
  text-align: center;
  background-color: rgb(239, 245, 250);
  font-weight: 600;
  color: #92969b;
  font-size: 15px;
}

.remarks-main {
  margin-top: 20px;
  font-size: 15px;
  color: #000000;
}

.pay-voucher-main {
  margin-top: 35px;
}

.pay-voucher-main .header-title {
  font-size: 16px;
  font-weight: 700;
  color: #303133;
  margin-bottom: 20px;
}

.voucher-image-container {
  width: 264px;
  height: 400px;
  background: #fff;
  display: inline-block;
}

.dialog-footer {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/ordermng/components/PaymentDetails.vue